import { tv } from 'tailwind-variants';

export const styles = {
  root: tv({ base: 'relative items-center justify-center' }),
  children: 'absolute top-0 left-0 w-full h-full',
};
